import { appUiSpec } from "@pericles/app-project-requirements-config";

function toSlug(value: string): string {
  return value
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/\s+|_+/g, "-")
    .toLowerCase();
}

export function getEntitySlug(entityName: string): string {
  const entitySpec = appUiSpec.entities.find((entity) => entity.entityName === entityName);

  if (entitySpec?.id) {
    return entitySpec.id;
  }

  return toSlug(entityName);
}
